import {domReady} from '@roots/sage/client';
import Alpine from 'alpinejs';
import scroll from './scroll-direction';


import '../views/blocks/team/team';
import '../views/blocks/arrow/arrow';
import '../views/blocks/banner/banner';
import '../views/blocks/criteria/criteria';
import '../views/blocks/ecosystem/ecosystem';
import '../views/blocks/facts/facts';
import '../views/blocks/headline/headline';
import '../views/blocks/heritage/heritage';
import '../views/blocks/hero/hero';
import '../views/blocks/image-and-text/image-and-text';
import '../views/blocks/mission/mission';
import '../views/blocks/news/news';
import '../views/blocks/offer/offer';
import '../views/blocks/portfolio/portfolio';


/**
 * app.main
 */
const main = async (err) => {
  if (err) {
    // handle hmr errors
    console.error(err);
  }

  // application code
};

/**
 * Initialize
 *
 * @see https://webpack.js.org/api/hot-module-replacement
 */
domReady(main);
import.meta.webpackHot?.accept(main);

Alpine.plugin(scroll);
window.Alpine = Alpine;
Alpine.start();
